<retrieval-call-flow [retrievalId]="ftId" [retrievalType]="ft" [callType]="callDirection"></retrieval-call-flow>
